// extracted by mini-css-extract-plugin
var _1 = "ProfileInfoWidgetFormFields-modulefields__d6ral FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
var _2 = "ProfileInfoWidgetFormFields-moduleformBody__GwjrT";
export { _1 as "fields", _2 as "formBody" }
